import React from 'react';
import PropTypes from 'prop-types';
import {
  wrapFormComponentWithLabelAndError,
  wrapFormComponentWithError,
} from './StyledFormComponentWrappers';

import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';

const RawRadioInput = ({ label, onChange, onBlur, ...rest }) => {
  // This allows us to send the real non-string value to redux-form
  // instead of the string version reported by the underlying HTML input
  // In particular, this is useful for booleans, for examlple.
  const alteredOnChange = e => onChange(rest.value);

  return (
    <label className="radio">
      <input type="radio" {...rest} onChange={alteredOnChange} /> {label}
    </label>
  );
};

RawRadioInput.displayName = 'RawRadioInput';

RawRadioInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
};

const RawRadioGroup = ({ options, ...otherInputProps }) => (
  <div>
    {options.map(({ value, label }) => (
      <RawRadioInput
        {...otherInputProps}
        key={value}
        value={value}
        checked={value === otherInputProps.value}
        label={label}
      />
    ))}
  </div>
);

RawRadioGroup.displayName = 'RawRadioGroup';

RawRadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
};

export { RawRadioInput, RawRadioGroup };

const RawRadioGroupField = wrapFormComponentWithLabelAndError(RawRadioGroup);
RawRadioGroupField.displayName = 'RawRadioGroupField';

const RadioGroupField = connectFormComponentToReduxForm(RawRadioGroupField);
RadioGroupField.displayName = 'RadioGroupField';

const RadioGroupInput = connectFormComponentToReduxForm(wrapFormComponentWithError(RawRadioGroup));

export { RadioGroupInput };

export default RadioGroupField;
